// extracted by mini-css-extract-plugin
export default {"base":"Summary_base__prIzy"};